<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import Editor from '@tinymce/tinymce-svelte';

  let apiKey = "xoifjvd46mymq6y2ev6wyaj7utyykb3tz9pf9v8m98oeiqip";

  let conf = {
    height: 500,
    plugins: [ 'autoresize', 'code', 'hr', 'image' ],
    toolbar: "undo redo | bold italic | hr image | code ",
    menubar: false,
    file_picker_types: 'image',
    /* and here's our custom image picker*/
    file_picker_callback: function (cb, value, meta) {
      var input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');

      input.onchange = function () {
        var file = this.files[0];

        var reader = new FileReader();
        reader.onload = function () {
          /*
            Note: Now we need to register the blob in TinyMCEs image blob
            registry. In the next release this part hopefully won't be
            necessary, as we are looking to handle it internally.
          */
          var id = 'blobid' + (new Date()).getTime();
          var blobCache =  tinymce.activeEditor.editorUpload.blobCache;
          var base64 = reader.result.split(',')[1];
          var blobInfo = blobCache.create(id, file, base64);
          blobCache.add(blobInfo);

          /* call the callback and populate the Title field with the file name */
          cb(blobInfo.blobUri(), { title: file.name });
        };
	      reader.readAsDataURL(file);
      };

      input.click();
    },
  };
  
  export let name, type, tags, attributes, description, saved_cards, selected_saved_card;
  
  const dispatch = createEventDispatcher();

  function change_tags(e) {
    dispatch("change_tags", {tags: e.target.value});
  }

  let tiny;
  
  const tinymceloaded = () => {
    tiny = window.tinymce.init({
      selector: "textarea.attributes"
    });
  }
</script>
<style>
  div.cardInput {
    width: 5in;
    display: flex;
    flex-direction: column;
  }
</style>

<div class="cardInput">
  <div class="row">Name: <input name="name" bind:value={name}/></div>
  <div class="row">Type: <input name="type" bind:value={type}/></div>
  <div class="row">Tags: <input name="tags" on:change={change_tags} value={tags}/></div>
  <div class="row">Attributes:
    <Editor {apiKey} {conf} bind:value={attributes}/>
  </div>
  <div class="row">Description:
    <Editor {apiKey} {conf} bind:value={description}/>
  </div>
  <div class="row">
    <select bind:value={selected_saved_card}>
      {#each saved_cards as card}
        <option value={card}>{card}</option>
      {/each}
    </select>
  </div>
  <div class="row">
    <button on:click={e => dispatch('add_card')}>+</button>
    <button on:click={e => dispatch('remove_card')}>-</button>
    <button on:click={e => dispatch('save_card')}>Save</button>
    <button on:click={e => dispatch('load_card')}>Load</button>
    <button on:click={e => dispatch('delete_card')}>Delete selected</button>
  </div>
</div>
